import { render, staticRenderFns } from "./HeroGrid.vue?vue&type=template&id=280b84fc&scoped=true"
import script from "./HeroGrid.vue?vue&type=script&lang=js"
export * from "./HeroGrid.vue?vue&type=script&lang=js"
import style0 from "./HeroGrid.vue?vue&type=style&index=0&id=280b84fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280b84fc",
  null
  
)

export default component.exports